/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Biginteger } from '../model';
// @ts-ignore
import { EnumOutputFormat } from '../model';
// @ts-ignore
import { Feature } from '../model';
// @ts-ignore
import { FeatureListWrapperVO } from '../model';
// @ts-ignore
import { Polygon } from '../model';
// @ts-ignore
import { PrintBodyVO } from '../model';
// @ts-ignore
import { PrintConfigVO } from '../model';
// @ts-ignore
import { PrintObjectVO } from '../model';
// @ts-ignore
import { PrintResponseVO } from '../model';
// @ts-ignore
import { TopicPrintRequestVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * PrintControllerApi - axios parameter creator
 * @export
 */
export const PrintControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} print 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf: async (print: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'print' is not null or undefined
            assertParamExists('downloadPdf', 'print', print)
            const localVarPath = `/api/print/download/{print}`
                .replace(`{${"print"}}`, encodeURIComponent(String(print)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPriloha: async (context: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('downloadPriloha', 'context', context)
            const localVarPath = `/api/print/download-priloha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrintConfig: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/print/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic ID tématu pro tisk.
         * @param {Array<Feature>} feature 
         * @param {EnumOutputFormat} [outputFormat] 
         * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeatures: async (topic: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('printFeatures', 'topic', topic)
            // verify required parameter 'feature' is not null or undefined
            assertParamExists('printFeatures', 'feature', feature)
            const localVarPath = `/api/print/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['outputFormat'] = outputFormat;
            }

            if (minScale !== undefined) {
                localVarQueryParameter['minScale'] = minScale;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feature, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu
         * @param {string} topic ID tématu pro tisk.
         * @param {PrintBodyVO} printBodyVO 
         * @param {string} [context] Kontextové informace pro tisk.
         * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
         * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
         * @param {Array<number>} [layerIds] ID vektorových vrstev.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeaturesForLayers: async (topic: string, printBodyVO: PrintBodyVO, context?: string, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('printFeaturesForLayers', 'topic', topic)
            // verify required parameter 'printBodyVO' is not null or undefined
            assertParamExists('printFeaturesForLayers', 'printBodyVO', printBodyVO)
            const localVarPath = `/api/print/features-for-layers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (forceBaseStyle !== undefined) {
                localVarQueryParameter['forceBaseStyle'] = forceBaseStyle;
            }

            if (backgroundLayerIds) {
                localVarQueryParameter['backgroundLayerIds'] = backgroundLayerIds;
            }

            if (layerIds) {
                localVarQueryParameter['layerIds'] = layerIds;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printBodyVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu
         * @param {string} topic ID tématu pro tisk.
         * @param {TopicPrintRequestVO} topicPrintRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeaturesForTopic: async (topic: string, topicPrintRequestVO: TopicPrintRequestVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('printFeaturesForTopic', 'topic', topic)
            // verify required parameter 'topicPrintRequestVO' is not null or undefined
            assertParamExists('printFeaturesForTopic', 'topicPrintRequestVO', topicPrintRequestVO)
            const localVarPath = `/api/print/features-for-topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicPrintRequestVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<PrintObjectVO>} printObjectVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeaturesLegacy: async (topic: string, printObjectVO: Array<PrintObjectVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('printFeaturesLegacy', 'topic', topic)
            // verify required parameter 'printObjectVO' is not null or undefined
            assertParamExists('printFeaturesLegacy', 'printObjectVO', printObjectVO)
            const localVarPath = `/api/print/download/print-features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printObjectVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} topic ID tématu pro tisk.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} [vyber] 
         * @param {FeatureListWrapperVO} [features] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printKladlistu: async (topic: string, format: string, vyska: number, sirka: number, vyber?: Polygon, features?: FeatureListWrapperVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('printKladlistu', 'topic', topic)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('printKladlistu', 'format', format)
            // verify required parameter 'vyska' is not null or undefined
            assertParamExists('printKladlistu', 'vyska', vyska)
            // verify required parameter 'sirka' is not null or undefined
            assertParamExists('printKladlistu', 'sirka', sirka)
            const localVarPath = `/api/print/klad-listu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (vyska !== undefined) {
                localVarQueryParameter['vyska'] = vyska;
            }

            if (sirka !== undefined) {
                localVarQueryParameter['sirka'] = sirka;
            }


            if (vyber !== undefined) { 
                localVarFormParams.append('vyber', new Blob([JSON.stringify(vyber)], { type: "application/json", }));
            }
    
            if (features !== undefined) { 
                localVarFormParams.append('features', new Blob([JSON.stringify(features)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} topic ID tématu pro tisk.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} polygon 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printKladlistuForTopic: async (topic: string, format: string, vyska: number, sirka: number, polygon: Polygon, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('printKladlistuForTopic', 'topic', topic)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('printKladlistuForTopic', 'format', format)
            // verify required parameter 'vyska' is not null or undefined
            assertParamExists('printKladlistuForTopic', 'vyska', vyska)
            // verify required parameter 'sirka' is not null or undefined
            assertParamExists('printKladlistuForTopic', 'sirka', sirka)
            // verify required parameter 'polygon' is not null or undefined
            assertParamExists('printKladlistuForTopic', 'polygon', polygon)
            const localVarPath = `/api/print/klad-listu-for-topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (vyska !== undefined) {
                localVarQueryParameter['vyska'] = vyska;
            }

            if (sirka !== undefined) {
                localVarQueryParameter['sirka'] = sirka;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(polygon, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Biginteger} idObjektKN 
         * @param {string} typ 
         * @param {boolean} castecnyVypis 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printListLv: async (idObjektKN: Biginteger, typ: string, castecnyVypis: boolean, context: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idObjektKN' is not null or undefined
            assertParamExists('printListLv', 'idObjektKN', idObjektKN)
            // verify required parameter 'typ' is not null or undefined
            assertParamExists('printListLv', 'typ', typ)
            // verify required parameter 'castecnyVypis' is not null or undefined
            assertParamExists('printListLv', 'castecnyVypis', castecnyVypis)
            // verify required parameter 'context' is not null or undefined
            assertParamExists('printListLv', 'context', context)
            const localVarPath = `/api/print/list-lv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idObjektKN !== undefined) {
                localVarQueryParameter['idObjektKN'] = idObjektKN;
            }

            if (typ !== undefined) {
                localVarQueryParameter['typ'] = typ;
            }

            if (castecnyVypis !== undefined) {
                localVarQueryParameter['castecnyVypis'] = castecnyVypis;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {string} [context] Kontextové informace pro tisk.
         * @param {string} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPdf: async (body: string, context?: string, format?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('printPdf', 'body', body)
            const localVarPath = `/api/print/create-json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrintControllerApi - functional programming interface
 * @export
 */
export const PrintControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrintControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} print 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPdf(print: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPdf(print, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPriloha(context: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPriloha(context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrintConfig(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrintConfigVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrintConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic ID tématu pro tisk.
         * @param {Array<Feature>} feature 
         * @param {EnumOutputFormat} [outputFormat] 
         * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printFeatures(topic: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printFeatures(topic, feature, outputFormat, minScale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu
         * @param {string} topic ID tématu pro tisk.
         * @param {PrintBodyVO} printBodyVO 
         * @param {string} [context] Kontextové informace pro tisk.
         * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
         * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
         * @param {Array<number>} [layerIds] ID vektorových vrstev.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printFeaturesForLayers(topic: string, printBodyVO: PrintBodyVO, context?: string, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printFeaturesForLayers(topic, printBodyVO, context, forceBaseStyle, backgroundLayerIds, layerIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu
         * @param {string} topic ID tématu pro tisk.
         * @param {TopicPrintRequestVO} topicPrintRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printFeaturesForTopic(topic: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printFeaturesForTopic(topic, topicPrintRequestVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<PrintObjectVO>} printObjectVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printFeaturesLegacy(topic: string, printObjectVO: Array<PrintObjectVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printFeaturesLegacy(topic, printObjectVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} topic ID tématu pro tisk.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} [vyber] 
         * @param {FeatureListWrapperVO} [features] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printKladlistu(topic: string, format: string, vyska: number, sirka: number, vyber?: Polygon, features?: FeatureListWrapperVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printKladlistu(topic, format, vyska, sirka, vyber, features, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} topic ID tématu pro tisk.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} polygon 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printKladlistuForTopic(topic: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printKladlistuForTopic(topic, format, vyska, sirka, polygon, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Biginteger} idObjektKN 
         * @param {string} typ 
         * @param {boolean} castecnyVypis 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printListLv(idObjektKN: Biginteger, typ: string, castecnyVypis: boolean, context: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printListLv(idObjektKN, typ, castecnyVypis, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} body 
         * @param {string} [context] Kontextové informace pro tisk.
         * @param {string} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printPdf(body: string, context?: string, format?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrintResponseVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.printPdf(body, context, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrintControllerApi - factory interface
 * @export
 */
export const PrintControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrintControllerApiFp(configuration)
    return {
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} print 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf(print: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadPdf(print, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPriloha(context: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadPriloha(context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrintConfig(options?: any): AxiosPromise<PrintConfigVO> {
            return localVarFp.getPrintConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic ID tématu pro tisk.
         * @param {Array<Feature>} feature 
         * @param {EnumOutputFormat} [outputFormat] 
         * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeatures(topic: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any): AxiosPromise<File> {
            return localVarFp.printFeatures(topic, feature, outputFormat, minScale, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu
         * @param {string} topic ID tématu pro tisk.
         * @param {PrintBodyVO} printBodyVO 
         * @param {string} [context] Kontextové informace pro tisk.
         * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
         * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
         * @param {Array<number>} [layerIds] ID vektorových vrstev.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeaturesForLayers(topic: string, printBodyVO: PrintBodyVO, context?: string, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any): AxiosPromise<File> {
            return localVarFp.printFeaturesForLayers(topic, printBodyVO, context, forceBaseStyle, backgroundLayerIds, layerIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu
         * @param {string} topic ID tématu pro tisk.
         * @param {TopicPrintRequestVO} topicPrintRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeaturesForTopic(topic: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any): AxiosPromise<File> {
            return localVarFp.printFeaturesForTopic(topic, topicPrintRequestVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<PrintObjectVO>} printObjectVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printFeaturesLegacy(topic: string, printObjectVO: Array<PrintObjectVO>, options?: any): AxiosPromise<string> {
            return localVarFp.printFeaturesLegacy(topic, printObjectVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} topic ID tématu pro tisk.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} [vyber] 
         * @param {FeatureListWrapperVO} [features] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printKladlistu(topic: string, format: string, vyska: number, sirka: number, vyber?: Polygon, features?: FeatureListWrapperVO, options?: any): AxiosPromise<File> {
            return localVarFp.printKladlistu(topic, format, vyska, sirka, vyber, features, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů).
         * @param {string} topic ID tématu pro tisk.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} polygon 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printKladlistuForTopic(topic: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any): AxiosPromise<File> {
            return localVarFp.printKladlistuForTopic(topic, format, vyska, sirka, polygon, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Biginteger} idObjektKN 
         * @param {string} typ 
         * @param {boolean} castecnyVypis 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printListLv(idObjektKN: Biginteger, typ: string, castecnyVypis: boolean, context: string, options?: any): AxiosPromise<string> {
            return localVarFp.printListLv(idObjektKN, typ, castecnyVypis, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body 
         * @param {string} [context] Kontextové informace pro tisk.
         * @param {string} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPdf(body: string, context?: string, format?: string, options?: any): AxiosPromise<PrintResponseVO> {
            return localVarFp.printPdf(body, context, format, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrintControllerApi - interface
 * @export
 * @interface PrintControllerApi
 */
export interface PrintControllerApiInterface {
    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} print 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    downloadPdf(print: string, options?: any): AxiosPromise<string>;

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    downloadPriloha(context: string, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    getPrintConfig(options?: any): AxiosPromise<PrintConfigVO>;

    /**
     * 
     * @param {string} topic ID tématu pro tisk.
     * @param {Array<Feature>} feature 
     * @param {EnumOutputFormat} [outputFormat] 
     * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printFeatures(topic: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any): AxiosPromise<File>;

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu
     * @param {string} topic ID tématu pro tisk.
     * @param {PrintBodyVO} printBodyVO 
     * @param {string} [context] Kontextové informace pro tisk.
     * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
     * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
     * @param {Array<number>} [layerIds] ID vektorových vrstev.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printFeaturesForLayers(topic: string, printBodyVO: PrintBodyVO, context?: string, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any): AxiosPromise<File>;

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu
     * @param {string} topic ID tématu pro tisk.
     * @param {TopicPrintRequestVO} topicPrintRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printFeaturesForTopic(topic: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {string} topic 
     * @param {Array<PrintObjectVO>} printObjectVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printFeaturesLegacy(topic: string, printObjectVO: Array<PrintObjectVO>, options?: any): AxiosPromise<string>;

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} topic ID tématu pro tisk.
     * @param {string} format velikost stránky (A4, A3, ...)
     * @param {number} vyska maximální výška čtverce
     * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
     * @param {Polygon} [vyber] 
     * @param {FeatureListWrapperVO} [features] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printKladlistu(topic: string, format: string, vyska: number, sirka: number, vyber?: Polygon, features?: FeatureListWrapperVO, options?: any): AxiosPromise<File>;

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} topic ID tématu pro tisk.
     * @param {string} format velikost stránky (A4, A3, ...)
     * @param {number} vyska maximální výška čtverce
     * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
     * @param {Polygon} polygon 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printKladlistuForTopic(topic: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {Biginteger} idObjektKN 
     * @param {string} typ 
     * @param {boolean} castecnyVypis 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printListLv(idObjektKN: Biginteger, typ: string, castecnyVypis: boolean, context: string, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {string} body 
     * @param {string} [context] Kontextové informace pro tisk.
     * @param {string} [format] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApiInterface
     */
    printPdf(body: string, context?: string, format?: string, options?: any): AxiosPromise<PrintResponseVO>;

}

/**
 * PrintControllerApi - object-oriented interface
 * @export
 * @class PrintControllerApi
 * @extends {BaseAPI}
 */
export class PrintControllerApi extends BaseAPI implements PrintControllerApiInterface {
    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} print 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public downloadPdf(print: string, options?: any) {
        return PrintControllerApiFp(this.configuration).downloadPdf(print, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public downloadPriloha(context: string, options?: any) {
        return PrintControllerApiFp(this.configuration).downloadPriloha(context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public getPrintConfig(options?: any) {
        return PrintControllerApiFp(this.configuration).getPrintConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic ID tématu pro tisk.
     * @param {Array<Feature>} feature 
     * @param {EnumOutputFormat} [outputFormat] 
     * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printFeatures(topic: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any) {
        return PrintControllerApiFp(this.configuration).printFeatures(topic, feature, outputFormat, minScale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu
     * @param {string} topic ID tématu pro tisk.
     * @param {PrintBodyVO} printBodyVO 
     * @param {string} [context] Kontextové informace pro tisk.
     * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
     * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
     * @param {Array<number>} [layerIds] ID vektorových vrstev.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printFeaturesForLayers(topic: string, printBodyVO: PrintBodyVO, context?: string, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any) {
        return PrintControllerApiFp(this.configuration).printFeaturesForLayers(topic, printBodyVO, context, forceBaseStyle, backgroundLayerIds, layerIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu
     * @param {string} topic ID tématu pro tisk.
     * @param {TopicPrintRequestVO} topicPrintRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printFeaturesForTopic(topic: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any) {
        return PrintControllerApiFp(this.configuration).printFeaturesForTopic(topic, topicPrintRequestVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {Array<PrintObjectVO>} printObjectVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printFeaturesLegacy(topic: string, printObjectVO: Array<PrintObjectVO>, options?: any) {
        return PrintControllerApiFp(this.configuration).printFeaturesLegacy(topic, printObjectVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} topic ID tématu pro tisk.
     * @param {string} format velikost stránky (A4, A3, ...)
     * @param {number} vyska maximální výška čtverce
     * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
     * @param {Polygon} [vyber] 
     * @param {FeatureListWrapperVO} [features] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printKladlistu(topic: string, format: string, vyska: number, sirka: number, vyber?: Polygon, features?: FeatureListWrapperVO, options?: any) {
        return PrintControllerApiFp(this.configuration).printKladlistu(topic, format, vyska, sirka, vyber, features, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů).
     * @param {string} topic ID tématu pro tisk.
     * @param {string} format velikost stránky (A4, A3, ...)
     * @param {number} vyska maximální výška čtverce
     * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
     * @param {Polygon} polygon 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printKladlistuForTopic(topic: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any) {
        return PrintControllerApiFp(this.configuration).printKladlistuForTopic(topic, format, vyska, sirka, polygon, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Biginteger} idObjektKN 
     * @param {string} typ 
     * @param {boolean} castecnyVypis 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printListLv(idObjektKN: Biginteger, typ: string, castecnyVypis: boolean, context: string, options?: any) {
        return PrintControllerApiFp(this.configuration).printListLv(idObjektKN, typ, castecnyVypis, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body 
     * @param {string} [context] Kontextové informace pro tisk.
     * @param {string} [format] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintControllerApi
     */
    public printPdf(body: string, context?: string, format?: string, options?: any) {
        return PrintControllerApiFp(this.configuration).printPdf(body, context, format, options).then((request) => request(this.axios, this.basePath));
    }
}
